import form_select_initial_state from './vehicle_select/initial_state'
import VeloxAPI from './api'

export const initial_state = {
	form_select: form_select_initial_state,
	API: VeloxAPI()
}

export default initial_state